import React from "react";
import { ExchangeFromTable as Table } from "./styles";
import moment from "moment";
import { ColumnTitleMobile, ColumnValue } from "../../styles";
import {
  Frequency as FrequencyTypeConstants
} from '../../constants';

function SpawnTable(props) {
  const { numberOfExchanges, frequency, startDate } = props;
  const columns = [
    {
      title: "Exchanges",
      className: "investment-pool-title hide-col-title-in-mobile",
      key: "id",
      render: (text) => {                       
        return (
          <div> {text.exchanges} </div>  
        )       
      }      
    },
    {
      title: "Next schedule date",
      className: "hide-col-title-in-mobile cell-w100",
      key: "nextScheduleDate",      
      render: (text) => {                       
          return <>
            <ColumnTitleMobile>Next schedule date</ColumnTitleMobile>
            <ColumnValue>{text.nextScheduleDate}</ColumnValue>            
          </>
      }
    }
  ];

  const nextDate = (frequency, startDate, each) => {
    let newEnd = moment(startDate);
    if (frequency === FrequencyTypeConstants.quaterly) {
      newEnd.add(Number(each) - 1, 'Q')
    } else if (frequency === FrequencyTypeConstants.monthly) {
      newEnd.add(Number(each) - 1, 'M')
    } else if (frequency === FrequencyTypeConstants.weekly) {
      newEnd.add(Number(each) - 1, 'w')
    }
    return newEnd.format("L");
  }

  const spawnsConfig = (numberOfExchanges, frequency, startDate) => {
    let spawnsArr = [];
    for (let each = 1; each <= numberOfExchanges; each++) {
      let obj = {
        id: each,
        exchanges: `Exchange ${each}`,
        nextScheduleDate: nextDate(frequency, startDate, each)
      };
      spawnsArr.push(obj);
    }
    return spawnsArr;
  }

  return (
    <div>
      <Table
        pagination={false}        
        columns={columns}
        dataSource={spawnsConfig(numberOfExchanges, frequency, startDate)}
      />
    </div>
  );
}

export default SpawnTable;
